import React from 'react';

const pinkColor = '#C72F62';

export const ConfirmTxt = ({ style, ...props }: React.HTMLAttributes<HTMLDivElement>) =>
  React.createElement('div', {
    style: {
      color: pinkColor,
      fontSize: '16px',
      fontWeight: 'bold',
      padding: '12px 60px',
      ...style
    },
    ...props
  });

export const ConfirmBody = ({ style, ...props }: React.HTMLAttributes<HTMLDivElement>) =>
  React.createElement('div', {
    style: {
      width: '100%',
      margin: '0 auto',
      ...style
    },
    ...props
  });
